import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@context/AuthContext'
import EmpresasManager from './EmpresasManager'
import UsuariosManager from './UsuariosManager'
import ModulosManager from './ModulosManager'
import LeadsManager from './LeadsManager'
import './AdminPanel.css'

const TABS = [
    { id: 'empresas',  label: '🏢 Empresas',  component: EmpresasManager },
    { id: 'usuarios',  label: '👥 Usuarios',   component: UsuariosManager },
    { id: 'modulos',   label: '🧩 Módulos',    component: ModulosManager  },
    { id: 'leads',     label: '📩 Leads',      component: LeadsManager    },
]

function AdminPanel() {
    const { isSuperAdmin, isLoading, userName } = useAuth()
    const [activeTab, setActiveTab] = useState('empresas')

    if (isLoading) {
        return (
            <div className="admin-loading">
                <div className="admin-spinner"></div>
                <p>Cargando panel de administración...</p>
            </div>
        )
    }

    if (!isSuperAdmin) {
        return <Navigate to="/dashboard" replace />
    }

    const ActiveComponent = TABS.find(t => t.id === activeTab)?.component || EmpresasManager

    return (
        <div className="admin-panel">
            {/* Header */}
            <div className="admin-header">
                <div className="admin-header-content">
                    <div className="admin-title-group">
                        <span className="admin-badge">SuperAdmin</span>
                        <h1 className="admin-title">Panel de Administración</h1>
                        <p className="admin-subtitle">Gestiona empresas, usuarios y módulos de Ingconia</p>
                    </div>
                    <div className="admin-user-info">
                        <div className="admin-avatar">
                            {userName.charAt(0).toUpperCase()}
                        </div>
                        <span>{userName}</span>
                    </div>
                </div>
            </div>

            {/* Tabs */}
            <div className="admin-tabs-bar">
                {TABS.map(tab => (
                    <button
                        key={tab.id}
                        className={`admin-tab ${activeTab === tab.id ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Content */}
            <div className="admin-content">
                <ActiveComponent />
            </div>
        </div>
    )
}

export default AdminPanel
